var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconeEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 178 161",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #e3e3e3;\n        opacity: 0.565;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_86",
    "data-name": "Group 86",
    transform: "translate(-1044 -460)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    className: "cls-1",
    cx: 80.5,
    cy: 80.5,
    r: 80.5,
    transform: "translate(1061 460)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_36",
    "data-name": "Group 36",
    transform: "translate(1044 496)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M103.672,0H12.179A12.234,12.234,0,0,0,0,12.179V77.086A12.234,12.234,0,0,0,12.179,89.265h91.641A12.234,12.234,0,0,0,116,77.086V12.179A12.462,12.462,0,0,0,103.672,0ZM5.941,21.536,36.835,44.113,5.941,67.432Zm103.969,55.4a6.276,6.276,0,0,1-6.238,6.238H12.179a6.276,6.276,0,0,1-6.238-6.238V74.858L41.885,47.826,51.836,55.1a9.92,9.92,0,0,0,6.09,1.931,10.06,10.06,0,0,0,6.09-2.079l8.466-6.387L109.91,75.9v1.04Zm0-8.318L77.531,44.855l32.379-24.21Zm0-55.252h0L60.451,50.351a4.023,4.023,0,0,1-5.05,0L5.941,14.259V12.179a6.276,6.276,0,0,1,6.238-6.238h91.641a6.276,6.276,0,0,1,6.238,6.238v1.188Z",
    transform: "translate(0 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeEmail);
export default __webpack_public_path__ + "static/media/icone_email.30d54d9d5e746c11ba9f102d92f9d0d5.svg";
export { ForwardRef as ReactComponent };